import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { packagerule_returndata } from 'src/types/packagerule_returndata'; 
import { bmxurl, byName, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { BusyService } from '../_services/busy.service';
import { resource } from 'src/types/resource';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class ResourceComponent implements OnInit {
  ListResources: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  httpResponse: any;
  ListResourceGroupNames: any[];

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService, private busyService: BusyService) { 

    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("RESOURCES", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(ResourceID)
  {
    this.http.delete(bmxurl + "Resource/" + this.VenueID + "/" + ResourceID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Resource successfully disabled'});
        this.router.navigateByUrl("/resource");

        this.loadgrid(false);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Disabled', detail: this.CreateUpdateResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Resource'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "ResourceList/" + this.VenueID + "/" + "/" + showdisabled).subscribe(response => {
      //Alphabetical. The order the Daysheet and itineraries use is set on the Daysheet Resource
      //Order page, not here.
      this.ListResources = byName((response as packagerule_returndata).data);

      if ((response as packagerule_returndata).messages.length > 0)
        {
          (response as packagerule_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }

    }, error => {
    });
  }

  editData(EditData)
  {
    let ResourceID = EditData;
    this.router.navigateByUrl("/resourceedit/" + ResourceID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    //resourceId, as the row button passes it - ResourceID was never a property, so every ticked
    //row asked the API to delete "undefined".
    this.http.delete(bmxurl + "Resource/" + this.VenueID + "/" + element.resourceId).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.loadgrid(false);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Disabled', detail:'An error occurred disabling one of the Resources'});
      }
    }, error => {
      //Was empty, which is why this went unnoticed - the calls failed in silence.
      this.messageService.add({severity:'error', summary:'Not Disabled', detail:'An error occurred disabling one of the Resources'});
    })
    });
    
  }

  
  }

